
	import {
		Component,
		Vue,
		Inject
	} from 'vue-property-decorator';
	import Footer from '../components/Footer.vue'
	// import TenantSwitch from '../components/tenant-switch.vue'
	import LanguageSwitch from '../components/language-switch.vue'
	import iView from 'iview';
	import AbpBase from '../lib/abpbase'
	import Util from '@/lib/util';
	import axios from 'axios';

	import url from '@/lib/url';

	@Component({
		components: {
			Footer,
			// TenantSwitch,
			LanguageSwitch
		}
	})

	export default class Login extends AbpBase {
		loginModel = {
			userNameOrEmailAddress: '',
			password: '',
			rememberMe: false
		}
		authorization: boolean = false
		passwordExpired: boolean = true
		showChangeTenant: boolean = false


		WelcomeMessage: Object = {
			en: "Welcome to IDS!",
			chs: "欢迎使用 IDS!"
		}
		CopyRight: Object = {
			en: "© 2018 IDS",
			chs: "© 2018 IDS"
		}
		LogIn: Object = {
			en: "Log in",
			chs: "登录"
		}
		RememberMe: Object = {
			en: "Remember me",
			chs: "记住我"
		}
		PasswordPlaceholder: Object = {
			en: "Please input a password",
			chs: "请输入密码"
		}
		UserNamePlaceholder: Object = {
			en: "Please enter your account",
			chs: "请输入账户"
		}
		LoginPrompt: Object = {
			en: "Login ...",
			chs: "正在登陆，请稍候！"
		}
		UserNameRequired: Object = {
			en: "Please enter your account",
			chs: "请输入账户"
		}
		PasswordRequired: Object = {
			en: "Please input a password",
			chs: "请输入密码"
		}


		L(name) {
			var n = '';
			if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
				n = name.en
			} else {
				n = name.chs
			}

			return n;

		}

		async login() {
			(this.$refs.loginform as any).validate(async (valid: boolean) => {
				if (valid) {
					this.$Message.loading({
						content: this.L(this.LoginPrompt),
						duration: 0
					})
					await this.$store.dispatch({
						type: 'app/login',
						data: this.loginModel
					})
					sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0');
					location.reload();
				}
			});
		}
		get tenant() {
			return this.$store.state.session.tenant;
		}
		rules = {
			userNameOrEmailAddress: [{
				required: true,
				message: this.L(this.UserNameRequired),
				trigger: 'blur'
			}],
			password: [{
				required: true,
				message: this.L(this.PasswordRequired),
				trigger: 'blur'
			}]
		}
		async created() {
			var that = this;
			var domain = sessionStorage.getItem('domain') as any;
			if (domain && domain != null && domain != '') {} else {
				domain = this.getQueryVariable("domain");
			}
			if (domain && domain != null && domain != '') {
				await this.$store.dispatch({
					type: 'app/externalAuthenticate',
					data: {
						"AuthProvider": "IDSDOMAIN",
						"ProviderAccessCode": domain,
						ProviderKey: "",
						Property: ""
					},
				})
				setTimeout(function() {
					//window.location.href = "https://gis.yfpo.com/#/main/home";
					location.reload();
				}, 2000)
				return;
			}



			if (process.env.NODE_ENV == "production") {
				var code = this.getQueryVariable("id_token");
				if (code != undefined && code != '') {
					this.authorization = false;
					var res = await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDS",
							"ProviderAccessCode": code,
							ProviderKey: "",
							Property: ""
						}
					})
					if (res.passwordExpired) {
						var before = localStorage.getItem('passwordExpireNotice');
						var nowDate = Util.formatDate(new Date(), 'yyyy-MM-dd');
						var now = (new Date()).getTime();
						var expiration = res.passwordExpirationDate * 1000;
						var expirationDate = Util.formatDate(new Date(expiration), 'yyyy-MM-dd');
						if (before == nowDate) {
							location.reload();
							return;
						}
						if (now >= expiration) {
							this.$Modal.warning({
								title: '提示 Tips',
								content: '密码已过期(' + expirationDate + ')，请修改密码！<br/>' +
									'Password expired，<br/>' +
									'Please modify password !',
								okText: "确认 OK",
								onOk: async () => {
									location.href = "/#/forgetPassword"
								}
							})
						} else {
							this.$Modal.confirm({
								title: '提示 Tips',
								content: '密码即将过期(' + expirationDate + ')，请修改密码！<br/>' +
									'Password will be expired，<br/>' +
									'Please modify password !',
								okText: "确认 OK",
								cancelText: "今日不再提醒 No more reminders today",
								onOk: async () => {
									location.href = "/#/forgetPassword"
									// this.$router.push({
									// 	path: '/forgetPassword'
									// })
								},
								onCancel: async () => {
									localStorage.setItem("passwordExpireNotice", nowDate);
									location.reload();
								},
							})
						}

					} else {
						setTimeout(function() {
							location.reload();
						}, 2000)
					}
				} else {
					var apiurl=url;
					console.log("debugger1:" + apiurl);

					var histname = window.location.hostname;

					if (histname.indexOf("gistest.yfpo.com") != -1) {
						//测试库
						console.log("debugger2:" + histname);
						that.gotoIdsAuth();
						// that.request(url, function(res) {
						// 			if (res) {
						// 				that.gotoIdsAuth();
						// 			}
						// })
					} else {
						//正式库
						console.log("debugger3:" + histname);
						that.request('https://private_check.yfpo.com/', function(res) {
							// alert(res ? '内网' : '外网')
							console.log("https://private_check.yfpo.com/:"+ res ? '内网' : '外网');
							
						})
						that.request('http://private_check.yfpo.com/', function(res) {
							// alert(res ? '内网' : '外网')
							console.log("http://private_check.yfpo.com/:"+ res ? '内网' : '外网');
							
						})
						//https://private_check.yfpo.com/
						that.request('https://gisapi.yfpo.com/', function(res) {
							// alert(res ? '内网' : '外网')
							console.log(res ? '内网' : '外网');
							if (res) {
								var url = 'http://gis.yfpo.local:8098/?direct=' + encodeURIComponent(location.href);
								location.href = url;
								console.log("debugger4:" + url);
							} else {
								if(apiurl.indexOf('9107')>-1){
									that.request('https://gis.yfpo.com:9107/', function(res) {
										if (res) {
											that.gotoIdsAuth();
										}
									})
								}else{
									that.request('/', function(res) {										
										if (res) {
											that.gotoIdsAuth();
										}
									})
								}
								
							}
						})
						
					}


				}
			} else {
				this.authorization = true;
			}

		}
		async gotoIdsAuth() {
			console.log("gotoIdsAuth1:"+window.location.hostname);
			if(window.location.hostname.indexOf('gistest.yfpo.com')>-1){
				var url = await this.$store.dispatch({
					type: 'app/getAuthorizeUrl',
					data: {}
				})
				console.log("gotoIdsAuth2:"+url);
				window.location.href = url;
			}
			else{
				var url = await this.$store.dispatch({
					type: 'app/getAuthorizeUrl',
					data: {}
				})
				if(window.location.port=="9185"){
					url=url.replace('yfjwt5','yfjwt70')
					console.log("gotoIdsAuth3:"+url);
					window.location.href = url;
				}
				else{		
					console.log("gotoIdsAuth4:"+url);
					window.location.href = url;
				}
			}
			
		}
		async request(url, res) {
			const ajax = axios.create({
				baseURL: url,
				timeout: 3000,
				headers: {
					'cache-control': 'no-cache',
					'Pragma': 'no-cache'
				}
			});
			ajax.interceptors.response.use((respon) => {
				return respon
			}, (error) => {
				// alert(JSON.stringify(error))
				res(false);
			})
			let response = await ajax.get('/AbpUserConfiguration/GetAll');
			if (response && response.status == 200) {
				res(true);
			}
		}

		resetPassword() {

		}
		cancelResetPassword() {
			location.reload();
		}
		getQueryVariable(p) {
			var query = window.location.search.substring(1);
			if (query == '') {
				var hashs = window.location.hash.split('?');
				if (hashs.length > 1) {
					query = hashs[1];
				}
				if (query.indexOf('#') > -1) {
					query = query.split('#')[0];
				}
			}
			var vars = query.split("&");
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split("=");
				if (pair[0] == p) {
					return pair[1];
				}
			}
			return (false);
		}
	}
